import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import getNameByID from "../../../../../functions/getNameByID";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PaidIcon from "@mui/icons-material/Paid";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function Contacts({ Attendee, setAttendee, Staff }) {
  const { logout } = StaffuseAuth();

  // Function to handle adding a new note
  const [newContact, setnewContact] = useState({
    Person: "",
    Email: "",
    Active: "",
  });

  // Function to handle changing the state of newContact
  const handleContactChange = (event) => {
    setnewContact({ ...newContact, [event.target.name]: event.target.value });
  };

  // Function to handle adding a new note
  const handleAddContact = () => {
    if (Attendee && Attendee.Contacts && Array.isArray(Attendee.Contacts)) {
      const updatedContacts = [...Attendee.Contacts, newContact];
      setAttendee({ ...Attendee, Contacts: updatedContacts });
      setnewContact({
        Person: "",
        Email: "",
        Active: "",
      }); // Clear the input field after submission
    } else {
      setAttendee({
        ...Attendee,
        Contacts: [newContact],
      });
      setnewContact({
        Person: "",
        Email: "",
        Active: "",
      }); // Clear the input field after submission
    }
  };

  // Function to handle the "Delete" button click
  const handleDelete = (index) => {
    const updatedContacts = [...Attendee.Contacts];
    updatedContacts.splice(index, 1);
    setAttendee({ ...Attendee, Contacts: updatedContacts });
  };

  //Function to handle the "Update" button click, which will remove the selected row from the array of Contacts using the index number and will take the data in Contacts and put it in the newContact state
  const handleUpdate = (Contact, index) => {
    const updatedContacts = [...Attendee.Contacts];
    updatedContacts.splice(index, 1);
    setAttendee({ ...Attendee, Contacts: updatedContacts });
    setnewContact(Contact);
  };

  const [isFormValid, setIsFormValid] = useState(false);
  //The below is the useEffect to check if the form is valid
  useEffect(() => {
    // Check if all required fields are filled out
    const checkFormValidity = () => {
      return (
        newContact.Person !== "" &&
        newContact.Email !== "" &&
        newContact.Active !== ""
      );
    };

    setIsFormValid(checkFormValidity());
  }, [newContact]); // This effect runs whenever the school state changes

  return (
    <section>
      <section>
        <h2>Contacts </h2>
      </section>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                className="tableCellHeader" // Add this line to include the CSS class
                align="left"
                style={{
                  position: "sticky",
                  Top: 0,
                  zIndex: 1,
                  fontWeight: "bold", // Make Text bold
                  padding: "8px", // Adjust padding as needed To make cells smaller
                }}
              >
                Person
              </TableCell>
              <TableCell
                className="tableCellHeader" // Add this line to include the CSS class
                align="left"
                style={{
                  position: "sticky",
                  Top: 0,
                  zIndex: 1,
                  fontWeight: "bold", // Make Text bold
                  padding: "8px", // Adjust padding as needed To make cells smaller
                }}
              >
                Email
              </TableCell>
              <TableCell
                className="tableCellHeader" // Add this line to include the CSS class
                align="left"
                style={{
                  position: "sticky",
                  Top: 0,
                  zIndex: 1,
                  fontWeight: "bold", // Make Text bold
                  padding: "8px", // Adjust padding as needed To make cells smaller
                }}
              >
                Active
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Attendee &&
            Attendee.Contacts &&
            Array.isArray(Attendee.Contacts) ? (
              Attendee.Contacts.map((Contact, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                      "& .MuiTableCell-root": {
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word", // Adjust padding here to make cells smaller
                      },
                    },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Contact.Person}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Contact.Email}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {Contact.Active}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleUpdate(Contact, index)}
                    >
                      Update
                    </Button>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleDelete(index)}
                      sx={{
                        backgroundColor: "red",
                        "&:hover": { backgroundColor: "darkred" },
                      }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: "20px" }}></div>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            label="Person"
            name="Person"
            value={newContact.Person}
            onChange={handleContactChange}
            fullWidth
            sx={{ marginBottom: "10px" }}
            select
          >
            <MenuItem value="Parent">Parent</MenuItem>
            <MenuItem value="Attendee">Attendee</MenuItem>
            <MenuItem value="Purchaser">Purchaser</MenuItem>
            <MenuItem value="Guardian">Guardian</MenuItem>
            <MenuItem value="EC">EC</MenuItem>
            <MenuItem value="Relative">Relative</MenuItem>
            <MenuItem value="Friend">Friend</MenuItem>
            <MenuItem value="Teacher">Teacher</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Email"
            name="Email"
            value={newContact.Email}
            onChange={handleContactChange}
            fullWidth
            sx={{ marginBottom: "10px" }}
            InputProps={{
              style: {
                backgroundColor: "white",
              },
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Active"
            name="Active"
            value={newContact.Active}
            onChange={handleContactChange}
            fullWidth
            sx={{ marginBottom: "10px" }}
            select
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      <Button
        variant="contained"
        color="primary"
        onClick={handleAddContact}
        disabled={!isFormValid}
      >
        Add Contact
      </Button>
    </section>
  );
}

export default Contacts;
